import styled from "styled-components";

const LayoutContainer = styled.div`
  padding-top: 64px;
`;

export default LayoutContainer;
